export default __webpack_public_path__ + "static/media/img_1.3fa22487.png";